import { useEffect } from 'react';

import {
  useBiopharmaGroupState,
  useBiopharmaGroupActions,
} from './BiopharmaGroupContext';

import {
  getBiopharmaGroup,
} from './restApi';

const BiopharmaGroupLoader = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError } = useBiopharmaGroupActions();

  useEffect(() => {
    if (biopharmaGroupState?.biopharmaGroup?.id) {
      getBiopharmaGroup({
        onResponse,
        onError,
        id: biopharmaGroupState?.biopharmaGroup?.id,
      });
    }
  }, [biopharmaGroupState?.biopharmaGroup?.id]);

  return null;
};

export default BiopharmaGroupLoader;
